import React, { useState, useRef } from 'react';
import { Layout } from '../components/Layout';
import { SEO, pageSEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Building2, Heart, Briefcase, Users, TrendingUp, Loader2, CheckCircle2, MessageCircle, Mail, Phone } from 'lucide-react';
import { sendViaWeb3Forms } from '../services/web3formsService';
import { saveSubmission } from '../services/databaseService';
export function DonatePage() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    email: '',
    telephone: '',
    message: ''
  });
  const [isProcessing, setIsProcessing] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.firstName.trim()) {
      alert('Veuillez entrer votre prénom.');
      return;
    }
    if (!formData.lastName.trim()) {
      alert('Veuillez entrer votre nom.');
      return;
    }
    if (!formData.email.trim() || !formData.email.includes('@')) {
      alert('Veuillez entrer une adresse email valide.');
      return;
    }
    setIsProcessing(true);
    try {
      const fields: Record<string, string> = {
        prenom: formData.firstName,
        nom: formData.lastName,
        email: formData.email,
        telephone: formData.telephone,
        organisation: formData.companyName,
        message: formData.message
      };
      await sendViaWeb3Forms({
        type: 'don',
        fields
      });
      setIsProcessing(false);
      setIsSuccess(true);
      window.scrollTo(0, 0);
    } catch (error) {
      console.error('Error submitting donation inquiry:', error);
      setIsProcessing(false);
      alert('Une erreur est survenue. Veuillez réessayer.');
    }
  };
  if (isSuccess) {
    return <Layout data-id="element-875">
        <SEO {...pageSEO.donate} data-id="element-876" />
        <div className="min-h-[60vh] flex items-center justify-center bg-gray-50 px-4 py-12" data-id="element-877">
          <Card className="max-w-md w-full text-center p-10 shadow-lg border-t-4 border-t-[#1E88E5]" data-id="element-878">
            <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-879">
              <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-880" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-881">
              Merci pour votre générosité !
            </h2>
            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-882">
              Votre demande a bien été enregistrée. Un membre de l'équipe ADCC
              vous contactera très prochainement pour organiser votre don et
              répondre à vos questions.
            </p>
            <Button onClick={() => {
            setIsSuccess(false);
            setFormData({
              firstName: '',
              lastName: '',
              companyName: '',
              email: '',
              telephone: '',
              message: ''
            });
          }} className="w-full text-lg py-6" data-id="element-883">
              Fermer
            </Button>
          </Card>
        </div>
      </Layout>;
  }
  return <Layout data-id="element-884">
      <SEO {...pageSEO.donate} data-id="element-885" />
      <div className="bg-[#2C3E50] text-white py-16" data-id="element-886">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-887">
          <span className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1 text-sm font-medium text-blue-200 mb-4" data-id="element-888">
            Faire un don
          </span>
          <h1 className="text-4xl font-bold mb-4" data-id="element-889">Soutenez l'ADCC</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-890">
            Votre contribution permet de financer nos actions de formation et
            d'accompagnement vers l'emploi digne au Bénin.
          </p>
        </div>
      </div>

      <div className="bg-gradient-to-b from-[#2C3E50] to-white pb-12" data-id="element-891">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-892">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 text-white text-center border border-white/20" data-id="element-893">
            <h2 className="text-2xl font-bold mb-2" data-id="element-894">Votre impact concret</h2>
            <p className="text-lg font-semibold" data-id="element-895">
              Soutenez l'insertion professionnelle durable.
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-896">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-897">
          <Card className="bg-blue-50 border-blue-100" data-id="element-898">
            <CardContent className="p-6 text-center" data-id="element-899">
              <Users className="w-8 h-8 text-[#1E88E5] mx-auto mb-4" data-id="element-900" />
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-901">Développer</h3>
              <p className="text-sm text-gray-600" data-id="element-902">
                Financer des ateliers de renforcement de capacités de qualité.
              </p>
            </CardContent>
          </Card>
          <Card className="bg-blue-50 border-blue-100" data-id="element-903">
            <CardContent className="p-6 text-center" data-id="element-904">
              <Briefcase className="w-8 h-8 text-[#1E88E5] mx-auto mb-4" data-id="element-905" />
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-906">Insérer</h3>
              <p className="text-sm text-gray-600" data-id="element-907">
                Soutenir les dispositifs de placement et mise en relation avec
                employeurs.
              </p>
            </CardContent>
          </Card>
          <Card className="bg-blue-50 border-blue-100" data-id="element-908">
            <CardContent className="p-6 text-center" data-id="element-909">
              <TrendingUp className="w-8 h-8 text-[#1E88E5] mx-auto mb-4" data-id="element-910" />
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-911">Suivre</h3>
              <p className="text-sm text-gray-600" data-id="element-912">
                Accompagner les bénéficiaires après leur placement pour garantir
                la durabilité.
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Impact Statement */}
        <div className="bg-gradient-to-r from-[#1E88E5] to-[#1976D2] rounded-2xl p-8 text-white mb-12" data-id="element-913">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-914">
            <div data-id="element-915">
              <p className="text-3xl font-bold mb-2" data-id="element-916">50€</p>
              <p className="text-sm text-blue-100" data-id="element-917">
                Finance le matériel pédagogique pour 2 bénéficiaires
              </p>
            </div>
            <div className="border-t md:border-t-0 md:border-l border-white/20 pt-6 md:pt-0" data-id="element-918">
              <p className="text-3xl font-bold mb-2" data-id="element-919">150€</p>
              <p className="text-sm text-blue-100" data-id="element-920">
                Forme et place 1 bénéficiaire
              </p>
            </div>
            <div className="border-t md:border-t-0 md:border-l border-white/20 pt-6 md:pt-0" data-id="element-921">
              <p className="text-3xl font-bold mb-2" data-id="element-922">500€</p>
              <p className="text-sm text-blue-100" data-id="element-923">
                Soutient le dispositif de placement pendant 1 mois
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-924">
          <div className="lg:col-span-2" data-id="element-925">
            <Card data-id="element-926">
              <CardContent className="p-8" data-id="element-927">
                <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-928">
                  Faites un don à l'ADCC
                </h2>
                <p className="text-gray-600 mb-6" data-id="element-929">
                  Remplissez ce formulaire et notre équipe vous contactera pour
                  organiser votre contribution.
                </p>
                <form onSubmit={handleSubmit} className="space-y-6" data-id="element-930">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-931">
                    <div data-id="element-932">
                      <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-933">
                        Prénom *
                      </label>
                      <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleInputChange} required disabled={isProcessing} className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border disabled:opacity-50" data-id="element-934" />
                    </div>
                    <div data-id="element-935">
                      <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-936">
                        Nom *
                      </label>
                      <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleInputChange} required disabled={isProcessing} className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border disabled:opacity-50" data-id="element-937" />
                    </div>
                  </div>

                  <div data-id="element-938">
                    <label htmlFor="companyName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-939">
                      Entreprise / Organisation (optionnel)
                    </label>
                    <div className="relative" data-id="element-940">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-941">
                        <Building2 className="h-5 w-5 text-gray-400" data-id="element-942" />
                      </div>
                      <input type="text" id="companyName" name="companyName" value={formData.companyName} onChange={handleInputChange} disabled={isProcessing} className="w-full pl-10 rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border disabled:opacity-50" data-id="element-943" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-944">
                    <div data-id="element-945">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-946">
                        Email *
                      </label>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} required disabled={isProcessing} className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border disabled:opacity-50" data-id="element-947" />
                    </div>
                    <div data-id="element-948">
                      <label htmlFor="telephone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-949">
                        Téléphone
                      </label>
                      <input type="tel" id="telephone" name="telephone" value={formData.telephone} onChange={handleInputChange} disabled={isProcessing} placeholder="+229..." className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border disabled:opacity-50" data-id="element-950" />
                    </div>
                  </div>

                  <div data-id="element-951">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-952">
                      Votre message (optionnel)
                    </label>
                    <textarea id="message" name="message" value={formData.message} onChange={handleInputChange} disabled={isProcessing} rows={4} placeholder="Précisez le type de soutien que vous souhaitez apporter, le montant envisagé, ou toute question..." className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border disabled:opacity-50" data-id="element-953" />
                  </div>

                  <Button type="submit" className="w-full text-lg py-6" disabled={isProcessing} data-id="element-954">
                    {isProcessing ? <>
                        <Loader2 className="w-5 h-5 mr-2 animate-spin" data-id="element-955" />
                        Envoi en cours...
                      </> : <>
                        <Heart className="w-5 h-5 mr-2" data-id="element-956" />
                        Envoyer ma demande de don
                      </>}
                  </Button>
                </form>
              </CardContent>
            </Card>
          </div>

          <div className="space-y-6" data-id="element-957">
            <Card className="bg-blue-50 border-none" data-id="element-958">
              <CardContent className="p-6" data-id="element-959">
                <div className="flex items-center gap-3 mb-4" data-id="element-960">
                  <div className="p-2 bg-[#1E88E5] rounded-full" data-id="element-961">
                    <MessageCircle className="w-5 h-5 text-white" data-id="element-962" />
                  </div>
                  <h3 className="font-bold text-gray-900" data-id="element-963">Prise de contact</h3>
                </div>
                <p className="text-sm text-gray-600 mb-4" data-id="element-964">
                  Après réception de votre formulaire, un membre de l'équipe
                  ADCC vous contactera personnellement pour discuter des
                  modalités de votre don et répondre à toutes vos questions.
                </p>
                <div className="space-y-3" data-id="element-965">
                  <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-966">
                    <Mail className="w-4 h-4 text-[#1E88E5]" data-id="element-967" />
                    <span data-id="element-968">contact@adcc.africa</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-969">
                    <Phone className="w-4 h-4 text-[#1E88E5]" data-id="element-970" />
                    <span data-id="element-971">+229 01 59 11 13 30</span>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-gray-50 border-none" data-id="element-972">
              <CardContent className="p-6" data-id="element-973">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-974">
                  Déduction fiscale
                </h3>
                <p className="text-sm text-gray-600" data-id="element-975">
                  L'ADCC étant une association reconnue, vos dons peuvent ouvrir
                  droit à une déduction fiscale selon la législation en vigueur
                  dans votre pays de résidence. Un reçu fiscal vous sera envoyé
                  automatiquement.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </Layout>;
}